// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__2La6h","row":"Table_row__JXdxl","col":"Table_col__3EQxa","foot":"Table_foot__1T5IZ","button":"Table_button__3oLMj","loader":"Table_loader__1gwgM"};